/** Allows to define slots in @see defineComponent function. */
/**
 * @__NO_SIDE_EFFECTS__
 */
export function defineSlots() {
    return undefined;
}
//# sourceMappingURL=slots.js.map